import { createSlice } from '@reduxjs/toolkit';
import {
  getPublicProducts,
  getPublicCategories,
  GetNewProduct,
} from './landingpage_service_syn';

const landpageSlice = createSlice({
  name: 'landpage',
  initialState: {
    products: {},
    categories: {},
    newProducts: {},
    loading: false,
    newLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPublicProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPublicProducts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.products = payload.data;
      })
      .addCase(getPublicProducts.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getPublicCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPublicCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.categories = payload.data;
      })
      .addCase(getPublicCategories.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(GetNewProduct.pending, (state) => {
        state.newLoading = true;
      })
      .addCase(GetNewProduct.fulfilled, (state, { payload }) => {
        state.newLoading = false;
        state.newProducts = payload.data;
      })
      .addCase(GetNewProduct.rejected, (state, { payload }) => {
        state.newLoading = false;
        state.error = payload;
      });
  },
});

export default landpageSlice.reducer;
